export default function (value, words, words_before = []) {
  if (words_before.length) {
    let value_1 = Math.abs(value) % 100
    let value_2 = value_1 % 10
    if (value_1 > 10 && value_1 < 20) {
      return words_before[2] + value + words[2]
    }
    if (value_2 > 1 && value_2 < 5) {
      return words_before[1] + value + words[1]
    }
    if (value_2 == 1) {
      return words_before[0] + value + words[0]
    }
    return words_before[2] + value + words[2]
  }
  let value_1 = Math.abs(value) % 100
  let value_2 = value_1 % 10
  if (value_1 > 10 && value_1 < 20) {
    return value + words[2]
  }
  if (value_2 > 1 && value_2 < 5) {
    return value + words[1]
  }
  if (value_2 == 1) {
    return value + words[0]
  }
  return value + words[2]
}
